import { render } from "./VideoPlayer.vue?vue&type=template&id=4c76d438&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"

import "./VideoPlayer.vue?vue&type=style&index=0&id=4c76d438&scoped=true&lang=css"

import exportComponent from "E:\\virtual-weather-station\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c76d438"]])

export default __exports__